import {Component, inject, OnInit} from '@angular/core';
import {select, Store} from "@ngrx/store";
import {selectStoreItems} from "../../../../store/entities/store-item/store-item.selectors";
import {StoreItemEntity} from "../../../../store/entities/store-item/store-item.model";
import {Observable} from "rxjs";
import {AppState} from "../../../../store/reducers";
import {StoreItemActions} from "../../../../store/entities/store-item/store-item.actions";
import {
  GET_STATISTIC_SITE_CATEGORIES
} from "../../../../store/entities/cms/statistic-site-category/statistic-site-category.graphql";
import {
  StatisticSiteCategory
} from "../../../../store/entities/cms/statistic-site-category/statistic-site-category.model";

@Component({
  selector: 'app-portal-static-sites',
  templateUrl: './portal-static-sites.component.html',
  styleUrl: './portal-static-sites.component.scss'
})
export class PortalStaticSitesComponent implements OnInit {
  statisticSites$: Observable<StatisticSiteCategory[]>

  store = inject(Store<AppState>);

  ngOnInit() {
    this.statisticSites$ = this.store.pipe(select(selectStoreItems(StoreItemEntity.statisticSiteCategory)))
    this.store.dispatch(StoreItemActions.getStoreItemsMergeMap({
      entity: StoreItemEntity.statisticSiteCategory,
      query: GET_STATISTIC_SITE_CATEGORIES,
      filtering: {}
    }))
  }


}
